import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Contentsection(props) {
    return (
        <div className="tekrevol_contentsection p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="HR Solutions">
                            <h2>Turnkey Human Resource Development And Management Solutions</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                        <p>Deploying a tailor-made business-centric HRMS solution for your enterprise is one of the
                            earliest steps you need to take toward 360-degree digital transformation. TekRevol’s HR
                            solutions deliver value and create impact by empowering employees at different levels,
                            creating performance accountability and transparency, and providing the freedom for remote
                            work management.</p>
                        <p>Building from scratch or using any other platform, our experienced CMS development team knows
                            what works best in the real world. Our customized CMS solution helps you in every phase –
                            from creating content to organizing and storing it appropriately to giving out permissions
                            and rights and managing all sorts of media files – manage everything from a single
                            platform.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Contentsection;